import axios from "axios";
import { API_URL } from "@/config";

export const TOKEN_KEY = "sxp_token";

export const api = axios.create({
    baseURL: `${API_URL}/api`,
    timeout: 60000,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});
